module.exports = __webpack_public_path__ + "img/logo-huawei.8b56721a.png";